export default __webpack_public_path__ + "static/logo-sri-certified-119b070fb4ace1a0836e60366ce2036a.png";